import {IProjectSettings, ITodoCreatedClosed} from "./Interfaces";
import {Plugin} from "./Main";
import {
    app,
    globalMatrix,
    IItem,
    ml,
    matrixSession,
    IDataStorage,
    matrixsdk,
    XRGetTodosAck,
    XRTodo,
    refLinkStyle,
    refLinkTooltip,
    Notifications,
    UIToolsConstants,
    TodoTypes,
    XRGetProject_Needle_TrimNeedle,
    INotificationConfig, notificationSetting, defaultNotificationConfig, ISearchResult
} from "../../../sdk/client";
import {IDashboardPage, IDashboardParametersBase} from "../../../sdk/plugins/interfaces";
import {Project} from "../../../sdk/objects/Project";
import { NotificationsBL } from "../../../core/common/businesslogic/NotificationsBL";


// eslint-disable-next-line no-unused-vars
export class DashboardPage implements IDashboardPage<IDashboardParametersBase> {
    settings: IProjectSettings;

    _root: JQuery;
    private notificationConfig: INotificationConfig;




    constructor(private project: Project, private projectStorage: IDataStorage,private popupModeOrControl = false, private currentFolder:string = undefined) {
        this.settings = {...Plugin.config.projectSettingsPage.defaultSettings, ...globalMatrix.ItemConfig.getSettingJSON(Plugin.config.projectSettingsPage.settingName, {})};
    }

    /** Customize static HTML here */
    private getDashboardDOM(): JQuery {
        return $(this.dashboardDOM);
    }

    /** Add interactive element in this function */
    renderProjectPage() {
        app.itemForm.append(
            ml.UI.getPageTitle(
                Plugin.config.dashboard.title,
                () => {
                    return this._root;
                },
                () => {
                    this.onResize();
                }
            )
        );
        app.itemForm.append(this.render());
    }

    public static getLastVisitedItems() {
        let lastVisitedItems = [];
        let items = globalMatrix.projectStorage.getItem("lastVisitedItems");
        if( items != undefined && items!="")
        {
            lastVisitedItems = JSON.parse(items);

        }
        if(lastVisitedItems == undefined)
        {
            lastVisitedItems = [];
        }
        return lastVisitedItems;
    }


    public render():JQuery {

        this.notificationConfig = <INotificationConfig>matrixsdk.getCustomerSettingJSON(notificationSetting, defaultNotificationConfig);
        let that = this;

        this._root = this.getDashboardDOM();
       $("#waitForIt",this._root).append(ml.UI.getSpinningWait());

        $(".plusctrl", this._root).click((e) => {
            if ($(e.target).hasClass("fa-minus-square")) {
                $(e.target).addClass("fa-plus-square");
                $(e.target).removeClass("fa-minus-square");
                $(e.target).closest(".panel").find(".panel-heading>span").hide();
            }
            else {
                $(e.target).removeClass("fa-plus-square");
                $(e.target).addClass("fa-minus-square");
                $(e.target).closest(".panel").find(".panel-heading>span").show();


            }
            $(e.target).parentsUntil(".panel").parent().find(".panel-body").toggle(100);
        });


        $(".panel-heading input[type='text']", this._root).on("keyup",  (e) => {
            let value = $(e.target).val().toLowerCase();
            $(e.target).parentsUntil(".panel").parent().find(".toBeFiltered").each( (index, elem) =>{
                $(elem).toggle($(elem).text().toLowerCase().indexOf(value) > -1)
            });
        });

        if (matrixsdk.isQMSProject(matrixsdk.getProject())) {
            //Hide XTC tab
            $("#tab-xtc").hide();
            $("li:has(a[href='#tab-xtc'])").hide();

        }
        else {
            //Hide tab training
            $("#tab-training", this._root).hide();
            $("li:has(a[href='#tab-training'])", this._root).hide();

        }
        let generalTodoTable = $("#userTodosTable", this._root);
        let reviewTodoTable = $("#reviewsTodosTable", this._root);
        let signatureTodoTable = $("#signatureTodosTable", this._root);
        let trainingTable = $("#trainingTodosTable", this._root);

        let needSignatureTodoTable = $("#needSignatureTodoTable", this._root);
        let reviewDoneTable = $("#reviewDoneTable", this._root);
        let needApproveTable = $("#needApproveTable", this._root);


        let xtcTable = $("#XTCTable", this._root);
        let todoCount = 0;
        app.waitForMainTree(async () => {
                if (this.notificationConfig.enabled) {
                        let todos =  await this.getTodos()
                        todoCount += that.generateTodoTable(todos, generalTodoTable, [TodoTypes.user], that.getItemIdAndTitleLink);
                        todoCount += that.generateTodoTable(todos, reviewTodoTable, [TodoTypes.needReview], that.getItemIdAndTitleLink);
                        todoCount += that.generateTodoTable(todos, reviewDoneTable, [TodoTypes.reviewsDone], that.getItemIdAndTitleLink);
                        todoCount += that.generateTodoTable(todos, signatureTodoTable, [TodoTypes.needSignature], that.getItemIdAndTitleLink);
                        todoCount += that.generateTodoTable(todos, needSignatureTodoTable, [TodoTypes.signaturesDone, TodoTypes.signatureRejected, TodoTypes.approveDone], that.getItemIdAndTitleLink);
                        if (matrixsdk.isQMSProject(matrixsdk.getProject())) {

                            todoCount += that.generateTodoTable(todos, needApproveTable, [TodoTypes.needApprove], that.getItemIdAndTitleLink);

                            // tab training
                            let trainingCount = that.generateTodoTable(todos, trainingTable, [TodoTypes.needTraining], that.getItemIdAndTitleLinkForQMS);
                            $("#trainingTab span.notificationIcon", this._root).html("" + trainingCount);
                            if (trainingCount == 0) {
                                $("#trainingTab span.notificationIcon", this._root).hide();
                            }


                        }
                        else {
                            needApproveTable.closest(".panel").hide();
                        }

                        $("#generalTab span.notificationIcon", this._root).html("" + todoCount);
                        if (todoCount == 0) {
                            $("#generalTab span.notificationIcon").hide();
                        }
                }
                else {
                    //Notification are disabled

                    generalTodoTable.closest(".panel").hide();
                    reviewTodoTable.closest(".panel").hide();
                    signatureTodoTable.closest(".panel").hide();
                    trainingTable.closest(".panel").hide();
                    needSignatureTodoTable.closest(".panel").hide();
                    reviewDoneTable.closest(".panel").hide();
                    needApproveTable.closest(".panel").hide();
                }
                let isQms = true;
                // XTC
                if (!matrixsdk.isQMSProject(matrixsdk.getProject())) {
                    that.generateXTCTable(xtcTable);
                    isQms = false;
                }

                let myLastWorkItem: string[] = DashboardPage.getLastVisitedItems();
                if (myLastWorkItem != undefined) {

                    let lastVisitedItemPanelUl = $("#lastVisitedPanel",this._root);

                    myLastWorkItem.forEach((itemid: string) => {

                        let p = $("<div />");
                        p.append(that.getItemIdAndTitleLink(itemid))
                        lastVisitedItemPanelUl.append(p);
                    })
                }

                if (isQms && !this.notificationConfig.enabled) {
                    // Let hide the left panel
                    $("#panelNotifContainer").hide();
                    $("#lastVisitedItems").removeClass("col-md-4").addClass("col-md-12");
                }
                this.installCopyPasteButtons();
                console.log("Highlighting references");
                // Highlight references after a while
                setTimeout(() => {
                    $(".myWork-notifications").highlightReferences();
                    $("#lastVisitedItems").highlightReferences();
                    $("#waitForIt",this._root).remove();
                },400);

        });


        return  this._root;

    }

    installCopyPasteButtons()
    {
        $(".panel-heading span.title ").each( (i, element) => {
            ml.UI.copyBuffer($(element),"Copy list to clipboard", $(element).closest(".panel").find(".panel-body"));
        });


    }
    getTodos():JQueryDeferred<XRGetTodosAck>
    {
        return <any>matrixsdk.getRestProject("todo");
    }

    generateXTCTable( table:JQuery)
    {
        let that = this;

        let assignedToMe = app.searchAsync("\"tester\" = \"" + matrixsdk.getUser() + "\" and (testResult =\"new\" or testResult=\"progress\") ");
        let unassigned = app.searchAsync("\"tester\" = \"\" and (testResult =\"new\" or testResult=\"progress\")");

        $.when(assignedToMe,unassigned).done(
            (response, response2:ISearchResult[]|undefined)=>{

                let template = table.find(".template")

                table.find(".addedNotifRow").remove();

                for(let i  = 0 ; i < response.length ; i++ )
                {
                    let newLine =template.clone().removeClass("template").removeClass("hidden").addClass("addedNotifRow");
                    let xtcItem = response[i];
                    newLine.find("td[data-attr='date']").html(xtcItem.creationDate);
                    newLine.find("td[data-attr='itemId']").html("");
                    newLine.find("td[data-attr='itemId']").append(that.getItemIdAndTitleLinkForXTC(xtcItem.itemId,xtcItem.title) );
                    newLine.find("td[data-attr='user']").html("me") ;

                    newLine.show();
                    newLine.appendTo(template.parent());
                }
                for(let i  = 0 ; i < response2.length ; i++ )
                {
                    let newLine =template.clone().removeClass("template").removeClass("hidden").addClass("addedNotifRow");
                    let xtcItem = response2[i];
                    newLine.find("td[data-attr='date']").html(xtcItem.creationDate);
                    newLine.find("td[data-attr='itemId']").html("");
                    newLine.find("td[data-attr='itemId']").append(that.getItemIdAndTitleLinkForXTC(xtcItem.itemId,xtcItem.title) );
                    newLine.find("td[data-attr='user']").html("unassigned") ;
                    newLine.show();
                    newLine.appendTo(template.parent());
                }



                if (response2.length == 0 && response.length == 0) {
                    let panel = table.closest(".panel");
                    panel.find(".panel-title").append("<small>No data to display</small>");
                    panel.find(".plusctrl").click();

                    table.append('<tr class="addedNotifRow" > <td colspan="4"> No data to display</td></tr>');
                    $("#xtcTab span.notificationIcon").hide();
                    panel.remove();
                    $("#panelNotifContainer").append(panel);
                }
                else
                {
                    $("#xtcTab span.notificationIcon").html( "" +(response.length + response2.length)) ;


                }
                template.hide();
                table.highlightReferences();
            });

    }
    generateTodoTable(response :XRGetTodosAck, table: JQuery,filter:TodoTypes[], linkBuilder:(id:string)=>JQuery):number
    {
        let notifications:XRTodo[] = [];
        let template = table.find(".template")
        if(response != undefined && response.todos != undefined)
        {

            notifications = response.todos.filter(o=> filter.indexOf( <TodoTypes> o.action.todoType)> -1);

            table.find(".addedNotifRow").remove();

            for(let i  = 0 ; i < notifications.length ; i++ )
            {
                let newLine =template.clone().removeClass("template").removeClass("hidden").addClass("addedNotifRow");
                let notif = notifications[i];

                newLine.find("[data-attr='originator']").html("");
                newLine.find("[data-attr='originator']").append ( ml.UI.getAvatar(notif.originatorLogin, 22));//+ " --> " + xtc.creationDate.format("YYYYMMDD") + "|" + xtc.executionDate.format("YYYYMMDD"));
                newLine.find("[data-attr='originator']").append ($("<span style='margin-left:6px' >" + notif.originatorLogin+ "</span>"));//+ " --> " + xtc.creationDate.format("YYYYMMDD") + "|" + xtc.executionDate.format("YYYYMMDD"));

                newLine.find("[data-attr='created']").html("");
                newLine.find("[data-attr='created']").append("Created " +  moment(new Date(notif.createdAt)).fromNow() +" by").attr("title",notif.createdAt);

                newLine.find("[data-attr='notification']").html( NotificationsBL.getMessage( notif ));
                newLine.find("[data-attr='itemId']").html("");
                newLine.find("[data-attr='itemId']").append(linkBuilder(notif.itemRef) );
                newLine.show();
                newLine.appendTo(template.parent());
            }
        }
        if (notifications.length == 0) {
            let panel = table.closest(".panel");
            panel.find(".panel-title").append("<small>No data to display</small>");
            panel.find(".plusctrl").click();

            table.append('<tr class="addedNotifRow" > <td colspan="4"> No data to display</td></tr>');
            panel.remove();
            $("#panelNotifContainer").append(panel);
        }
        else
        {
            let panel = table.closest(".panel");
            panel.find(".panel-title").append("<small>"+ notifications.length+ " items</small>");
        }
        template.hide();

        return notifications.length;
    }
    getItemIdAndTitleLink(itemRef:string):JQuery
    {

        let link = $("<span>" + itemRef + "!</span>");
        return  link ;
    }
    getItemIdAndTitleLinkForXTC(itemRef:string, title:string):JQuery
    {
        itemRef =  itemRef.substr(0, itemRef.lastIndexOf("-"))
        let link = $("<span>" + itemRef + "!</span>");
        return  link ;


    }
    getItemIdAndTitleLinkForQMS(itemRef:string):JQuery
    {
        return $("<a target='_blank' href='" + globalMatrix.matrixBaseUrl + "/pub/" + matrixsdk.getProject() + "/?show=" + itemRef + "'>" + itemRef + "</a>" + " " + app.getItemTitle(itemRef));
    }

    onResize() {
        /* Will be triggered when resizing. */
    }

    private dashboardDOM =`
            <div class="panel-body-v-scroll panel-default fillHeight">
            <div id="waitForIt"> </div>
            <div class="">
                <div >
                    <br/>
                    <div class="row" style="margin:0px;">
                        <div class="col-md-8" style="position:static" id="panelNotifContainer">
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <span style="float:right;margin-top:-5px;"> Filter: <input type="text"/></span>
                                    <h3 class="panel-title"><span class="title"> Notifications</span>
                                        <span class="fal plusctrl fa-minus-square" />
                                    </h3>
                                </div>
                                <div class="panel-body myWork-notifications" id="userTodosTable">

                                    <div class="panel template hidden toBeFiltered">
                                            <div class="row">
                                                <div class="col-md-9">
                                                <div class="itemdId" data-attr="itemId"><a href="/WWWheely/SPEC-2" target="_blank" data-original-title="" title=""><span class="refId refIdHyper">SPEC-2</span></a><span class="key-SPEC-2 refTitle">Auto Emergency Brakes</span></div>
                                                    <div class="nofification" data-attr="notification"> xxxx my notifmy notif my notif my notif my notif my notif  </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <p class="created"  data-attr="created">created few second ago by</p>
                                                    <p class="originator" data-attr="originator">Francois</p>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <span style="float:right;margin-top:-5px;"> Filter: <input type="text"/></span>
                                    <h3 class="panel-title"><span class="title"> Reviews Pending</span>
                                        <span class="fal plusctrl fa-minus-square" />
                                    </h3>
                                </div>
                                <div class="panel-body myWork-notifications" id="reviewsTodosTable">
                                  <div class="panel template hidden toBeFiltered">
                                            <div class="row">
                                                <div class="col-md-9">
                                                <div class="itemdId" data-attr="itemId"><a href="/WWWheely/SPEC-2" target="_blank" data-original-title="" title=""><span class="refId refIdHyper">SPEC-2</span></a><span class="key-SPEC-2 refTitle">Auto Emergency Brakes</span></div>
                                                    <div class="nofification" data-attr="notification"> xxxx my notifmy notif my notif my notif my notif my notif  </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <p class="created"  data-attr="created">created few second ago by</p>
                                                    <p class="originator" data-attr="originator">Francois</p>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                            <div class="panel-heading">
                                <span style="float:right;margin-top:-5px;"> Filter: <input type="text"/></span>
                                <h3 class="panel-title"><span class="title"> Reviews done</span>
                                    <span class="fal plusctrl fa-minus-square" />
                                </h3>
                            </div>
                            <div class="panel-body myWork-notifications" id="reviewDoneTable">
                              <div class="panel template hidden toBeFiltered">
                                        <div class="row">
                                            <div class="col-md-9">
                                            <div class="itemdId" data-attr="itemId"><a href="/WWWheely/SPEC-2" target="_blank" data-original-title="" title=""><span class="refId refIdHyper">SPEC-2</span></a><span class="key-SPEC-2 refTitle">Auto Emergency Brakes</span></div>
                                                <div class="nofification" data-attr="notification"> xxxx my notifmy notif my notif my notif my notif my notif  </div>
                                            </div>
                                            <div class="col-md-3">
                                                <p class="created"  data-attr="created">created few second ago by</p>
                                                <p class="originator" data-attr="originator">Francois</p>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <span style="float:right;margin-top:-5px;"> Filter: <input type="text"/></span>
                                    <h3 class="panel-title"><span class="title">Signatures Pending</span>
                                        <span class="fal plusctrl fa-minus-square" />
                                    </h3>
                                </div>
                                <div class="panel-body myWork-notifications" id="signatureTodosTable">
                                  <div class="panel template hidden toBeFiltered">
                                            <div class="row">
                                                <div class="col-md-9">
                                                <div class="itemdId" data-attr="itemId"><a href="/WWWheely/SPEC-2" target="_blank" data-original-title="" title=""><span class="refId refIdHyper">SPEC-2</span></a><span class="key-SPEC-2 refTitle">Auto Emergency Brakes</span></div>
                                                    <div class="nofification" data-attr="notification"> xxxx my notifmy notif my notif my notif my notif my notif  </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <p class="created"  data-attr="created">created few second ago by</p>
                                                    <p class="originator" data-attr="originator">Francois</p>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                            <div class="panel-heading">
                                <span style="float:right;margin-top:-5px;"> Filter: <input type="text"/></span>
                                <h3 class="panel-title"><span class="title">Signatures done/rejected</span>
                                    <span class="fal plusctrl fa-minus-square" />
                                </h3>
                            </div>
                            <div class="panel-body myWork-notifications" id="needSignatureTodoTable">
                              <div class="panel template hidden toBeFiltered">
                                        <div class="row">
                                            <div class="col-md-9">
                                            <div class="itemdId" data-attr="itemId"><a href="/WWWheely/SPEC-2" target="_blank" data-original-title="" title=""><span class="refId refIdHyper">SPEC-2</span></a><span class="key-SPEC-2 refTitle">Auto Emergency Brakes</span></div>
                                                <div class="nofification" data-attr="notification"> xxxx my notifmy notif my notif my notif my notif my notif  </div>
                                            </div>
                                            <div class="col-md-3">
                                                <p class="created"  data-attr="created">created few second ago by</p>
                                                <p class="originator" data-attr="originator">Francois</p>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                            <div class="panel panel-default" id="tab-training">
                                <div class="panel-heading">
                                    <span style="float:right;margin-top:-5px;"> Filter: <input type="text"/></span>
                                    <h3 class="panel-title"><span class="title">Training</span>
                                        <span class="fal plusctrl fa-minus-square" />
                                    </h3>
                                </div>
                              <div class="panel-body myWork-notifications" id="trainingTodosTable">
                                  <div class="panel template hidden">
                                            <div class="row">
                                                <div class="col-md-9">
                                                <div class="itemdId" data-attr="itemId"><a href="/WWWheely/SPEC-2" target="_blank" data-original-title="" title=""><span class="refId refIdHyper">SPEC-2</span></a><span class="key-SPEC-2 refTitle">Auto Emergency Brakes</span></div>
                                                    <div class="nofification" data-attr="notification"> xxxx my notifmy notif my notif my notif my notif my notif  </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <p class="created"  data-attr="created">created few second ago by</p>
                                                    <p class="originator" data-attr="originator">Francois</p>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default" id="tab-needApprove">
                                <div class="panel-heading">
                                    <span style="float:right;margin-top:-5px;"> Filter: <input type="text"/></span>
                                    <h3 class="panel-title"><span class="title">Pending Template Approvals</span>
                                        <span class="fal plusctrl fa-minus-square" />
                                    </h3>
                                </div>
                              <div class="panel-body myWork-notifications" id="needApproveTable">
                                  <div class="panel template hidden">
                                            <div class="row">
                                                <div class="col-md-9">
                                                <div class="itemdId" data-attr="itemId"><a href="/WWWheely/SPEC-2" target="_blank" data-original-title="" title=""><span class="refId refIdHyper">SPEC-2</span></a><span class="key-SPEC-2 refTitle">Auto Emergency Brakes</span></div>
                                                    <div class="nofification" data-attr="notification"> xxxx my notifmy notif my notif my notif my notif my notif  </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <p class="created"  data-attr="created">created few second ago by</p>
                                                    <p class="originator" data-attr="originator">Francois</p>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default" id="tab-xtc">
                                <div class="panel-heading">
                                    <span style="float:right;margin-top:-5px;"> Filter: <input type="text"/></span>
                                    <h3 class="panel-title"><span class="title">Tests to be executed</span>
                                        <span class="fal plusctrl fa-minus-square" />
                                    </h3>
                                </div>
                                <div class="panel-body">
                                    <div class="table-responsive">
                                        <table class="table table-condensed table-hover" id="XTCTable">
                                            <thead>
                                                <tr>
                                                    <th class="col-md-5">Item</th>
                                                    <th class="col-md-2">Created at</th>
                                                    <th class="col-md-2">Assigned to </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="template hidden toBeFiltered">
                                                    <td data-attr="itemId"></td>
                                                    <td data-attr="date">Cell 2</td>
                                                    <td data-attr="user">Cell 2</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div><span></span></div>
                            </div>
                        </div>

                        <div class="col-md-4" id="lastVisitedItems">
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h3 class="panel-title">Last opened items</h3>
                                </div>
                                <div class="panel-body" id="lastVisitedPanel">
                                    <div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> `;
}
